module.exports = __webpack_public_path__ + "img/image-005.07bc9328.png";